import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  Paper, 
  Tabs, 
  Tab, 
  Box, 
  Button,
  Typography,
  Grid
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import LogoutIcon from '@mui/icons-material/Logout';

const Navigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    navigate(newValue);
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <Paper sx={{ mb: 3 }}>
      <Box sx={{ p: 2 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={8}>
            <Typography variant="h5" color="primary" sx={{ mb: 1 }}>
              Document Review System
            </Typography>
            <Tabs 
              value={location.pathname} 
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab 
                label="Slack Messages" 
                value="/messages" 
                sx={{ textTransform: 'none', fontSize: '16px' }}
              />
              <Tab 
                label="Zendesk Tickets" 
                value="/zendesk" 
                sx={{ textTransform: 'none', fontSize: '16px' }}
              />
            </Tabs>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                variant="outlined"
                color="primary"
                startIcon={<LogoutIcon />}
                onClick={handleLogout}
                sx={{ height: '40px' }}
              >
                Logout
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

export default Navigation; 